export default [
    {
        path: '/outing-tras',
        name: 'outstanding',
        meta: {
            title: 'Outstanding Payments',
            authRequired: true,
        },
        component: ()=> import('../views/payments/index')
    },
    {
        path: '/paymts',
        name: 'payments',
        meta: {
            title: 'Payments',
            authRequired: true,
        },
        component: () => import('../views/payments/payments') 
    },
    {
        path: '/checkyout',
        name: 'checkout',
        meta: {
            title: 'Checkout',
            authRequired: true,
        },
        component: () => import('../views/payments/checkout') 
    },
    {
        path: '/success-ful-payment',
        name: 'Successful',
        meta: {
            title: 'payment Success',
            authRequired: true,
        },
        component: () => import('../views/payments/success') 
    },
    
    {
        path: '/failed-payment',
        name: 'failed',
        meta: {
            title: 'Payment Failed ',
            authRequired: true,
        },
        component: () => import('../views/payments/failed') 
    },

]